import React, { useState, useEffect } from "react";
import ReactLoading from "react-loading";
const MapForm = () => {
  const handleRedirect = () => {
    window.open(
      "https://www.google.com/maps/place/Comfort+Zone+Solution/@25.2468947,86.9907217,17z/data=!3m1!4b1!4m6!3m5!1s0x39f0499e0cea5981:0xfc9f7947f16c0a88!8m2!3d25.2468947!4d86.9932966!16s%2Fg%2F11njt29hxc?entry=ttu&g_ep=EgoyMDI2MDUxMy4wIKXMDSoASAFQAw%3D%3D",
      "_blank"
    );
  };

  return (
    <div className="container w-full px-6 py-2 mx-auto">
      <div className="relative overflow-hidden rounded-lg shadow-md">
        
        {/* Click Overlay */}
        <div
          className="absolute inset-0 z-10 cursor-pointer"
          onClick={handleRedirect}
        ></div>

        {/* Google Map */}
        <iframe
          title="Comfort Zone Solution Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.7039454288597!2d86.99072167496196!3d25.246894677678892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f0499e0cea5981%3A0xfc9f7947f16c0a88!2sComfort%20Zone%20Solution!5e0!3m2!1sen!2sin!4v1779358119080!5m2!1sen!2sin"
          width="100%"
          height="600"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          className="w-full"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        {/* Loading Text */}
        <div className="py-2 text-sm text-center text-gray-500 bg-white">
          Map loading...
        </div>
      </div>
    </div>
  );
};

export default MapForm;
// dsfs